import { ApprovalPolicyVersion } from '@/types/approvals'
import useGetDetail, { UseGetDetailOptions } from '../core-hooks/useGetDetail'
import useGetList, { UseGetListOptions } from '../core-hooks/useGetList'
import buildService from '../create-service'
import queryKeys from '../query-keys'

const service = buildService<ApprovalPolicyVersion>({
  pathCategory: 'approval_policy_versions',
})

export function useGetApprovalPolicyVersions({
  filters,
  ...options
}: UseGetListOptions<ApprovalPolicyVersion> = {}) {
  const query = useGetList<ApprovalPolicyVersion>({
    filters,
    queryKey: queryKeys.approvalPolicyVersions.list({ filters }),
    serviceFn: service.getList,
    ...options,
  })

  return {
    approvalPolicyVersions: query.allData,
    ...query,
  }
}

export function useGetApprovalPolicyVersion({
  id,
  ...options
}: UseGetDetailOptions<ApprovalPolicyVersion>) {
  const query = useGetDetail<ApprovalPolicyVersion>({
    id,
    queryKey: queryKeys.approvalPolicyVersions.detail({
      id,
      filters: options.filters,
    }),
    serviceFn: service.getDetail,
    ...options,
  })

  return {
    approvalPolicyVersion: query.data,
    ...query,
  }
}
